import { useState, useEffect } from "react";


function Origin({ origin_url }){
    const [originData, setOriginData] = useState([]);
    useEffect(() => {
        if (origin_url) {
            fetch(origin_url)
                .then(response => response.json())
                .then(data => setOriginData(data))
                .catch(error => console.error("Error fetching origin data:", error));
        }
    }, [origin_url]);

    return(
        <div>
            {origin_url ? 
            <p>Origin Name: {originData.name}</p> : <p>No origin data available.</p>}
        </div>
    )
}

export default Origin;